import React, { useRef } from 'react';
import { StyleSheet, View, } from 'react-native';
import { Button } from '@rneui/themed';
import BottomSheet, { BottomSheetView } from '@gorhom/bottom-sheet';
import { Portal } from '@gorhom/portal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '../../../hooks';
import { BottomSheetBackdrop, FAIcon, useSleepTimer } from '../../..';
import { TimePicker, Timer } from '../timer';
export const UnmemoizedSleepTimer = ({ size, buttonStyle, iconStyle, }) => {
    const { sleepTime, setSleepTime } = useSleepTimer();
    const { top, bottom } = useSafeAreaInsets();
    const { colors } = useTheme();
    const bottomSheetRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: styles.button },
            sleepTime && (React.createElement(Timer, { style: styles.timer })),
            React.createElement(Button, { type: "clear", onPress: () => bottomSheetRef.current?.expand(), style: buttonStyle },
                React.createElement(FAIcon, { name: "stopwatch", size: size, style: iconStyle }))),
        React.createElement(Portal, { hostName: "modal" },
            React.createElement(BottomSheet, { ref: bottomSheetRef, backdropComponent: BottomSheetBackdrop, index: -1, topInset: top, enablePanDownToClose: true, backgroundStyle: { backgroundColor: colors.backgroundPrimary }, handleIndicatorStyle: { backgroundColor: colors.textPrimary }, containerStyle: { zIndex: 3000 } },
                React.createElement(BottomSheetView, { style: {
                        backgroundColor: colors.backgroundPrimary,
                        paddingBottom: bottom,
                    } },
                    React.createElement(View, { style: { alignItems: 'center' } },
                        React.createElement(Timer, { style: { marginBottom: 10 } }),
                        React.createElement(TimePicker, null)),
                    React.createElement(Button, { disabled: !sleepTime, buttonStyle: styles.cancelButton, onPress: () => setSleepTime && setSleepTime(), title: "Cancel" }))))));
};
export const SleepTimer = React.memo(UnmemoizedSleepTimer, (prev, next) => {
    return prev.size === next.size;
});
const styles = StyleSheet.create({
    button: {
        alignContent: 'center',
        alignItems: 'center',
    },
    timer: {
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
        top: -5,
    },
    cancelButton: {
        alignSelf: 'center',
        marginTop: 20,
        marginBottom: 40,
        paddingHorizontal: 40,
    },
});
//# sourceMappingURL=SleepTimer.js.map